module.exports = __webpack_public_path__ + "media/bootstrap-icons/arrow-right-circle-30c0367d.svg";